import useTranslation from "@/hooks/useTranslation";
import {
  UniqueRouteLeg,
  useGetInboundTransportUniqueRoute,
  useUpdateInboundSingleOrderRoute,
} from "@/hooks/useTransport";
import { message } from "antd";
import { ReactNode, useState } from "react";
import RouteWizard from "./RouteWizard";

export default function InboundOrderRouteWizard({
  children,
  orderId,
  departureId,
  arrivalId,
  transportCategory,
  year,
}: {
  children: ReactNode;
  orderId: string;
  departureId: number;
  arrivalId: number;
  transportCategory: string;
  year?: number;
}) {
  const saveMutation = useUpdateInboundSingleOrderRoute();
  const [isOpen, setIsOpen] = useState(false);
  const t = useTranslation();

  const { data, isLoading } = useGetInboundTransportUniqueRoute({
    year,
    departureId,
    arrivalId,
    transportCategory,
    enabled: isOpen,
    orderId,
  });

  const onSave = (route: UniqueRouteLeg[]) => {
    if (!orderId) return message.error(t.errors.general);

    saveMutation
      .mutateAsync({
        orderId,
        departureId,
        arrivalId,
        transportCategory,
        route: { route },
      })
      .then(() => {
        setIsOpen(false);
      });
  };

  return (
    <>
      <span onClick={() => setIsOpen(true)}>{children}</span>
      {isOpen && (
        <RouteWizard
          loading={isLoading}
          onClose={() => setIsOpen(false)}
          route={data?.route}
          departure={data?.departure}
          arrival={data?.arrival}
          count={data?.total_count}
          isOpen={isOpen}
          arrivalType={"facility"}
          onSave={onSave}
          isSaving={saveMutation.isLoading}
        />
      )}
    </>
  );
}
